import React, { Component } from "react";
import { Link, Redirect, matchPath } from "react-router-dom";
import Header from "../../../User/Header";
import TabelaFormador from "./Tabelas/Formador";
import TabelaAluno from "./Tabelas/Aluno";
import TabelaSessoes from "./Tabelas/Sessoes";
import TabelaHistorico from "./Tabelas/Historico";
import axios from "axios";
import moment from "moment";
import { GlobalContext } from "../../../app/providers/GlobalState";
import { DatePicker, Icon, Modal, notification, Tooltip, Alert } from "antd";

import ModalGerarDocumento from "../../../shared/components/Modals/GerarDocumento";

import { noimage } from "../../../assets";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

export class Main extends Component {
    static contextType = GlobalContext;
    state = {
        dt_inicio: moment().subtract(1, "month"),
        dt_termino: moment(),
        utilizador: "",
        formador: false,
        //utilizadorid: 0,
        //formador: true,
        filtroAtivo: "",
        //items: ["Instrutor", "Aluno", "Sessões", "Histórico"],
        //foto_aluno: "",
        //nome_aluno: "",
        //REDIRECT
        redirect: false,
        redirectLink: "",
        //EXPORTAR
        visibleExportar: false,
        btnDescarregar: false,
        ficheiroExportar: "",
        //ATUALIZAR
        atualizar: false
    };

    UNSAFE_componentWillMount() {
        const utilizador = JSON.parse(localStorage.getItem("sis_utilizador"));
        this.setState({
            utilizador
        });
    }

    componentDidUpdate() {
        if (!this.context.is_authenticated || this.context.role === "UTILIZADOR" || this.context.role === "FORMADOR") {
            if (!this.context.is_authenticated)
                this.setState({
                    redirect: true,
                    redirectLink: "/login"
                });
            else if (this.context.role === "UTILIZADOR" || this.context.role === "FORMADOR")
                this.setState({
                    redirect: true,
                    redirectLink: "/user"
                });
        }
    }

    onChangeDataInicio = dt_inicio => {
        this.setState({
            dt_inicio
        });
    };

    onChangeDataTermino = dt_termino => {
        this.setState({
            dt_termino
        });
    };

    ativarFiltro(index) {
        this.setState({ filtroAtivo: index });
    }

    exportarFormadorCSV = () => {
        this.setState(
            {
                visibleExportar: true,
                btnDescarregar: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/gestao-exportar/formador",
                    params: {
                        utilizadorid: this.state.utilizador.id,
                        dtini: this.state.dt_inicio.format("YYYY/MM/DD"),
                        dtfim: this.state.dt_termino.format("YYYY/MM/DD")
                    }
                })
                    .then(response => {
                        this.setState({
                            btnDescarregar: false,
                            ficheiroExportar: response.data
                        });
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                        this.setState({
                            visibleExportar: false
                        });
                    });
            }
        );
    };

    exportarFormadorDet = () => {
        this.setState(
            {
                visibleExportar: true,
                btnDescarregar: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/gestao-exportar/formador-det",
                    params: {
                        utilizadorid: this.state.utilizador.id,
                        dtini: this.state.dt_inicio.format("YYYY/MM/DD"),
                        dtfim: this.state.dt_termino.format("YYYY/MM/DD")
                    }
                })
                    .then(response => {
                        this.setState({
                            btnDescarregar: false,
                            ficheiroExportar: response.data
                        });
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                        this.setState({
                            visibleExportar: false
                        });
                    });
            }
        );
    };

    exportarAlunoCSV = () => {
        this.setState(
            {
                visibleExportar: true,
                btnDescarregar: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/gestao-exportar/aluno",
                    params: {
                        utilizadorid: this.state.utilizador.id,
                        dtini: this.state.dt_inicio.format("YYYY/MM/DD"),
                        dtfim: this.state.dt_termino.format("YYYY/MM/DD")
                    }
                })
                    .then(response => {
                        this.setState({
                            btnDescarregar: false,
                            ficheiroExportar: response.data
                        });
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                        this.setState({
                            visibleExportar: false
                        });
                    });
            }
        );
    };

    exportarAlunoDet = () => {
        this.setState(
            {
                visibleExportar: true,
                btnDescarregar: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/gestao-exportar/aluno-det",
                    params: {
                        utilizadorid: this.state.utilizador.id,
                        dtini: this.state.dt_inicio.format("YYYY/MM/DD"),
                        dtfim: this.state.dt_termino.format("YYYY/MM/DD")
                    }
                })
                    .then(response => {
                        this.setState({
                            btnDescarregar: false,
                            ficheiroExportar: response.data
                        });
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                        this.setState({
                            visibleExportar: false
                        });
                    });
            }
        );
    };

    exportarSessoesCSV = () => {
        this.setState(
            {
                visibleExportar: true,
                btnDescarregar: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/gestao-exportar/aluno-sessoes",
                    params: {
                        utilizadorid: this.state.utilizador.id,
                        dtini: this.state.dt_inicio.format("YYYY/MM/DD"),
                        dtfim: this.state.dt_termino.format("YYYY/MM/DD")
                    }
                })
                    .then(response => {
                        this.setState({
                            btnDescarregar: false,
                            ficheiroExportar: response.data
                        });
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                        this.setState({
                            visibleExportar: false
                        });
                    });
            }
        );
    };

    exportarSessoesDet = () => {
        this.setState(
            {
                visibleExportar: true,
                btnDescarregar: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/gestao-exportar/aluno-sessoes-det",
                    params: {
                        utilizadorid: this.state.utilizador.id,
                        dtini: this.state.dt_inicio.format("YYYY/MM/DD"),
                        dtfim: this.state.dt_termino.format("YYYY/MM/DD")
                    }
                })
                    .then(response => {
                        this.setState({
                            btnDescarregar: false,
                            ficheiroExportar: response.data
                        });
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                        this.setState({
                            visibleExportar: false
                        });
                    });
            }
        );
    };

    exportarHistoricoDet = () => {
        this.setState(
            {
                visibleExportar: true,
                btnDescarregar: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/gestao-exportar/aluno-historico",
                    params: {
                        utilizadorid: this.state.utilizador.id,
                        dtini: this.state.dt_inicio.format("YYYY/MM/DD"),
                        dtfim: this.state.dt_termino.format("YYYY/MM/DD")
                    }
                })
                    .then(response => {
                        this.setState({
                            btnDescarregar: false,
                            ficheiroExportar: response.data
                        });
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                        this.setState({
                            visibleExportar: false
                        });
                    });
            }
        );
    };

    pesquisar = () => {
        let diff = this.state.dt_termino.diff(this.state.dt_inicio, "months");
        let diffDays = this.state.dt_termino.diff(this.state.dt_inicio, "days");

        if (diff >= 0 && diff <= 5 && diffDays >= 0) this.setState({ atualizar: true });
        else if (diff < 0 || diffDays < 0)
            openNotificationWithIcon("warning", "Atenção", "A data de Inicio deve ser inferior a data de Término");
        else openNotificationWithIcon("warning", "Atenção", "O intervalo das duas datas não deve ser superior a 6 meses");
    };

    paraAtualizar = () => {
        this.setState({
            atualizar: false
        });
    };

    render() {
        const {
            dt_inicio,
            dt_termino,
            filtroAtivo,
            //items,
            utilizador,
            //formador,
            //REDIRECT
            redirect,
            redirectLink,
            //EXPORTAR
            visibleExportar,
            btnDescarregar,
            ficheiroExportar,
            //ATUALIZAR
            atualizar
        } = this.state;

        if (redirect) return <Redirect to={redirectLink} />;

        const opcoesMenu = () => {
            if (utilizador.formador) {
                return ["Professor", "Aluno", "Sessões", "Histórico"];
            } else {
                return ["Aluno", "Sessões", "Histórico"];
            }
        };

        const montarTitulo = () => {
            if (filtroAtivo === "Professor" || (!filtroAtivo && opcoesMenu().length === 4)) return "Estatisticas enquanto professor";
            else if (filtroAtivo === "Aluno" || (!filtroAtivo && opcoesMenu().length === 3)) return "Estatisticas enquanto aluno";
            else if (filtroAtivo === "Sessões") return "Sessões na plataforma";
            else return "Histórico de navegação";
        };

        return (
            <>
                <Header titulo={montarTitulo()} />
                <div className="administracao-estatisticas bloco-estatisticas-utilizador">
                    <div className="container">
                        <div
                            className="bloco bloco-gestao-estatistica"
                            style={{ background: "white", borderRadius: "4px 4px 0 0", padding: 30 }}
                        >
                            {utilizador && (
                                <div className="bloco-flex">
                                    <div className="bloco-info" style={{ padding: 0 }}>
                                        <div className="dados-user">
                                            <div className="container-img">
                                                <img src={utilizador.foto ? utilizador.foto : noimage} alt="" />
                                            </div>
                                            <div>
                                                <h6 style={{ marginBottom: 0 }}>{utilizador.nome}</h6>
                                                <span style={{ fontSize: 12 }}>{utilizador.numero}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <Link
                                        to="/gestao-utilizadores-todos"
                                        className="botao-secundario botao-secundario-redondo"
                                        title="Voltar"
                                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                                    >
                                        <Icon type="arrow-left" />
                                    </Link>
                                </div>
                            )}
                        </div>
                        <div className="bloco-grid" style={{ marginTop: 0 }}>
                            <div className="filtros" style={{ borderRadius: "0 0 0 4px" }}>
                                <ul>
                                    {opcoesMenu().map((item, index) => (
                                        <li
                                            key={index}
                                            className={filtroAtivo === item || (!filtroAtivo && index === 0) ? "ativo" : ""}
                                            onClick={() => this.ativarFiltro(item)}
                                        >
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="bloco-cursos-estatisticas">
                                <div className="combo-datas combo-datas-desktop" style={{ margin: "30px 20px 10px" }}>
                                    <div style={{ marginRight: 20, fontSize: 16 }}>
                                        <Tooltip className="info-icon" title="Intervalo máximo de 6 meses">
                                            <Icon type="question-circle-o" />
                                        </Tooltip>
                                    </div>
                                    <div className="inicio">
                                        <label>Inicio:</label>
                                        <DatePicker
                                            value={dt_inicio}
                                            placeholder="Data Inicio"
                                            format="DD/MM/YYYY"
                                            onChange={this.onChangeDataInicio}
                                        />
                                    </div>
                                    <div className="termino">
                                        <label>Término:</label>
                                        <DatePicker
                                            value={dt_termino}
                                            placeholder="Data Término"
                                            format="DD/MM/YYYY"
                                            onChange={this.onChangeDataTermino}
                                        />
                                    </div>
                                    <button className="procurar" onClick={this.pesquisar}>
                                        <Icon type="search" />
                                    </button>
                                </div>
                                <div className="combo-datas combo-datas-mobile" style={{ padding: "30px 30px 15px" }}>
                                    <Alert message="Intervalo máximo de 6 meses" type="info" showIcon />
                                    <div className="bloco-filtro-datas">
                                        <div className="inicio">
                                            <label>Inicio:</label>
                                            <DatePicker
                                                value={dt_inicio}
                                                placeholder="Data Inicio"
                                                format="DD/MM/YYYY"
                                                onChange={this.onChangeDataInicio}
                                            />
                                        </div>
                                        <div className="termino">
                                            <label>Término:</label>
                                            <DatePicker
                                                value={dt_termino}
                                                placeholder="Data Término"
                                                format="DD/MM/YYYY"
                                                onChange={this.onChangeDataTermino}
                                            />
                                        </div>
                                        <button className="procurar" onClick={this.pesquisar}>
                                            <Icon type="search" />
                                        </button>
                                    </div>
                                </div>
                                {(filtroAtivo === "Professor" || (!filtroAtivo && opcoesMenu().length === 4)) && ( // QUANDO FORMADOR
                                    <>
                                        <TabelaFormador
                                            dt_inicio={dt_inicio}
                                            dt_termino={dt_termino}
                                            atualizar={atualizar}
                                            paraAtualizar={this.paraAtualizar}
                                        />
                                        <div className="botoes-exportar">
                                            <Link to="#" onClick={this.exportarFormadorCSV}>
                                                <Icon type="export" />
                                                Exportar resumo para csv
                                            </Link>
                                            <Link to="#" onClick={this.exportarFormadorDet}>
                                                <Icon type="export" />
                                                Exportar detalhe para csv
                                            </Link>
                                        </div>
                                    </>
                                )}
                                {(filtroAtivo === "Aluno" || (!filtroAtivo && opcoesMenu().length === 3)) && ( // QUANDO ALUNO
                                    <>
                                        <TabelaAluno
                                            dt_inicio={dt_inicio}
                                            dt_termino={dt_termino}
                                            atualizar={atualizar}
                                            paraAtualizar={this.paraAtualizar}
                                        />
                                        <div className="botoes-exportar">
                                            <Link to="#" onClick={this.exportarAlunoCSV}>
                                                <Icon type="export" />
                                                Exportar resumo para csv
                                            </Link>
                                            <Link to="#" onClick={this.exportarAlunoDet}>
                                                <Icon type="export" />
                                                Exportar detalhe para csv
                                            </Link>
                                        </div>
                                    </>
                                )}
                                {filtroAtivo === "Sessões" && ( // QUANDO SESSÕES
                                    <>
                                        <TabelaSessoes
                                            dt_inicio={dt_inicio}
                                            dt_termino={dt_termino}
                                            atualizar={atualizar}
                                            paraAtualizar={this.paraAtualizar}
                                        />
                                        <div className="botoes-exportar">
                                            <Link to="#" onClick={this.exportarSessoesCSV}>
                                                <Icon type="export" />
                                                Exportar resumo para csv
                                            </Link>
                                            <Link to="#" onClick={this.exportarSessoesDet}>
                                                <Icon type="export" />
                                                Exportar detalhe para csv
                                            </Link>
                                        </div>
                                    </>
                                )}
                                {filtroAtivo === "Histórico" && ( // QUANDO HISTORICO
                                    <>
                                        <TabelaHistorico
                                            dt_inicio={dt_inicio}
                                            dt_termino={dt_termino}
                                            atualizar={atualizar}
                                            paraAtualizar={this.paraAtualizar}
                                        />
                                        <div className="botoes-exportar">
                                            <Link to="#" onClick={this.exportarHistoricoDet}>
                                                <Icon type="export" />
                                                Exportar detalhe para csv
                                            </Link>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <ModalGerarDocumento
                    visibleExportar={visibleExportar}
                    ficheiroExportar={ficheiroExportar}
                    btnDescarregar={btnDescarregar}
                    onClose={() => this.setState({ visibleExportar: false })}
                />
            </>
        );
    }
}

export default Main;
